
import themes from "@/mixins/themes"
import Tag from "@/components/base/Tag"
import { DEFAULT_THEME_LIGHT } from "@/helpers/themesHelper"

export default {
    name: "JobPageTags",
    components: { Tag },
    mixins: [themes],
    props: {
        tags: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        // oaTheme.tags contains 5 colors, if more tags are available, we need to repeat the colors
        tagColors() {
            const themeTagColors =
                this.oaTheme?.tags || DEFAULT_THEME_LIGHT.tags
            return Array(Math.ceil(this.tags.length / themeTagColors.length))
                .fill(themeTagColors)
                .flat()
        },
    },
}
